module.exports = __webpack_public_path__ + "static/media/play-score-3.81437317.png";